import heic2any from "heic2any";

let photoCount = 0;

export const convertBase64TextToFile = async (base64Content) => {
  const res = await fetch(base64Content);
  const blob = await res.blob();
  return new File([blob], "materialImage", { type: "image/png" });
};

export const resizeFile = (img) => {
  var MAX_WIDTH = 300;
  var MAX_HEIGHT = 300;

  var width = img.width;
  var height = img.height;

  if (width > height) {
    if (width > MAX_WIDTH) {
      height = height * (MAX_WIDTH / width);
      width = MAX_WIDTH;
    }
  } else {
    if (height > MAX_HEIGHT) {
      width = width * (MAX_HEIGHT / height);
      height = MAX_HEIGHT;
    }
  }

  var canvas = document.createElement("canvas");
  canvas.width = width;
  canvas.height = height;
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, width, height);
  return canvas.toDataURL();
};

export const processUploadedImage = async (imgFile) => {
  if (
    imgFile?.name?.toLowerCase().endsWith(".heic") ||
    imgFile?.name?.toLowerCase().endsWith(".heif")
  ) {
    let appleImage = await heic2any({
      blob: imgFile,
      toType: "image/png",
    });
    appleImage.lastModified = imgFile.lastModified;
    try {
      appleImage.name = imgFile.name.substring(0, imgFile.name.indexOf("."));
    } catch {
      appleImage.name = "";
    }
    imgFile = new File([appleImage], "materialImage", { type: "image/png" });
  }
  return imgFile;
};

export const createImgObject = (imgFile) => {
  return {
    id: `photo_${photoCount++}`,
    key: imgFile.lastModified.toString(),
    lastModified: imgFile.lastModified,
    name: imgFile.name,
    size: imgFile.size,
    type: imgFile.type,
    url: "",
  };
};
